import { trans } from '@tools/translation';
import { initExpandableTextContent } from '@organisms/page-details/enableExpandableTextContent';

export const initSpaceDetails = () => {
  if (!document.querySelector('.space-details')) {
    return;
  }

  document.querySelector('.office-services__expand-button')?.addEventListener('click', () => {
    const officeServicesSection = document.querySelector('.space-details__services');

    if (!officeServicesSection) {
      return;
    }

    officeServicesSection.classList.toggle('expanded');

    document.querySelector('.office-services__expand-button').textContent = officeServicesSection.classList.contains('expanded')
      ? trans('global.see_less') : trans('global.see_more');
  });

  initExpandableTextContent();
};
